import { cn } from "@/ui/lib/utils";

export const SkeletonBlock = ({ className }: { className?: string }) => (
  <div className={cn("bg-state-loading", className)} />
);
